import css from 'styled-jsx/css';

const styles = css`.news-banner{display:block;padding:4px 16px;background-color:#67cac9;color:#fff;text-decoration:underline;text-align:center;font-size:14px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}`;

export default styles;